import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, BadgeCheck, Star, Lock, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EnquiryDialog } from "@/components/discovery/EnquiryDialog";

export const VendorCard = ({ v }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md transition-shadow" data-testid={`vendor-card-${v.slug}`}>
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0">
        <Link to={`/vendors/vendor/${v.slug}`} className="font-semibold text-slate-900 hover:text-teal line-clamp-1">{v.name}</Link>
        <p className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><MapPin className="h-3 w-3" /> {v.city}{v.locality ? ` · ${v.locality}` : ""}</p>
      </div>
      <div className="flex flex-col items-end gap-1 shrink-0">
        {v.sponsored && <span className="rounded-full bg-amber-100 text-amber-800 px-2 py-0.5 text-[10px] font-bold uppercase">Sponsored</span>}
        {v.featured && !v.sponsored && <span className="rounded-full bg-indigo-100 text-indigo-700 px-2 py-0.5 text-[10px] font-bold uppercase">Featured</span>}
      </div>
    </div>
    {v.is_demo && <span className="inline-block mt-2 rounded bg-slate-100 text-slate-500 px-1.5 py-0.5 text-[10px] font-semibold">{v.demo_label || "Demo Vendor – Example Profile"}</span>}
    <p className="text-sm text-slate-600 mt-2 line-clamp-2">{v.description}</p>
    {v.services?.length > 0 && (
      <div className="mt-2 flex flex-wrap gap-1">
        {v.services.slice(0, 4).map((s) => <span key={s} className="rounded-full bg-teal-brand/10 text-teal px-2 py-0.5 text-[11px]">{s}</span>)}
      </div>
    )}
    <div className="mt-3 flex items-center justify-between text-xs text-slate-500">
      <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {v.business_hours}</span>
      {v.feedback_summary && <span className="flex items-center gap-1 text-emerald-600"><Star className="h-3 w-3 fill-emerald-500 text-emerald-500" /> {v.feedback_summary.positive}/{v.feedback_summary.total} positive</span>}
    </div>
    <div className="mt-3 flex items-center gap-2">
      <EnquiryDialog
        categorySlug={v.category_slug} subcategorySlug={v.subcategory_slug} vendorSlug={v.slug}
        trigger={<Button size="sm" className="bg-teal-brand hover:bg-teal-700 text-white flex-1" data-testid={`vendor-enquiry-${v.slug}`}>Contact through platform</Button>}
      />
      {v.website ? (
        <a href={v.website} target="_blank" rel="noreferrer" className="text-xs text-teal inline-flex items-center gap-1"><Globe className="h-3.5 w-3.5" /> Website</a>
      ) : (
        <span className="text-[11px] text-slate-400 inline-flex items-center gap-1"><Lock className="h-3 w-3" /> Contact on consent</span>
      )}
    </div>
    <p className="mt-2 text-[10px] text-slate-400 flex items-center gap-1"><BadgeCheck className="h-3 w-3" /> Status: {v.verification_status} · Profile {v.profile_completion}% · Updated {(v.last_updated || "").slice(0, 10)}</p>
  </div>
);
